import { VuiInfoTooltip } from "../../../lib";

export const InfoTooltip = () => {
  return <VuiInfoTooltip tip="This explains a term or feature." />;
};
